import React from 'react';
import { Building2, AlertCircle } from 'lucide-react';

const CmsSelector: React.FC = () => {

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <Building2 className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Acesso ao CMS
          </h1>
          <p className="text-gray-600">
            Selecione o CMS correto para continuar
          </p>
        </div>

        {/* Alert */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h3 className="text-sl font-medium text-amber-800 mb-1">
                Caminho do CMS Obrigatório
              </h3>
              <p className="text-sl text-amber-700">
                Para acessar o sistema, você deve usar o caminho específico do seu CMS. 
                Entre em contato com seu administrador para obter o link correto.
              </p>
            </div>
          </div>
        </div>


        {/* Instructions */}
        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="font-medium text-gray-900 mb-2">Como acessar seu CMS:</h4>
          <ul className="text-sl text-gray-600 space-y-1">
            <li>• Use o link específico fornecido pelo seu administrador</li>
            <li>• O link deve ter o formato: <code className="bg-gray-200 px-1 rounded">seudominio.com/seu-cms/login</code></li>
            <li>• Cada CMS tem suas próprias configurações e permissões</li>
          </ul>
        </div>
        {/* Removido botão de redirecionamento - cada revendedor deve usar seu próprio slug */}

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            Se você não tem acesso ao link correto, entre em contato com o suporte técnico.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CmsSelector;
